// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, enableIndexedDbPersistence, CACHE_SIZE_UNLIMITED } from "firebase/firestore";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase services
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

// تمكين التخزين المحلي
enableIndexedDbPersistence(db, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED,
  synchronizeTabs: true
}).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn('التخزين المحلي يتطلب تبويب واحد مفتوح في كل مرة.');
  } else if (err.code === 'unimplemented') {
    console.warn('المتصفح لا يدعم التخزين المحلي.');
  }
  // نستمر حتى مع وجود خطأ في التخزين المحلي
});

const auth = getAuth(app);
const storage = getStorage(app);

// Debug logging
console.log('Firebase Config:', {
    hasApiKey: !!firebaseConfig.apiKey,
    hasAuthDomain: !!firebaseConfig.authDomain,
    hasProjectId: !!firebaseConfig.projectId,
    projectId: firebaseConfig.projectId
});

// إعداد المصادقة المحلية
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('تم تعيين المصادقة المحلية بنجاح');
  })
  .catch((error) => {
    console.error('خطأ في تعيين المصادقة:', error);
  });

// Export the Firebase services
export { app, analytics, db, auth, storage };